import React from 'react';
import type { LifeProfile } from '../types/life';
import { ProfileForm } from './ProfileForm';
import { StrikeRow } from './StrikeRow';
interface OnboardingProps {
  onSubmit: (profile: LifeProfile) => void;
}
const DEMO_ROWS: Array<{
  from: number;
  fraction: number;
}> = [{
  from: 1990,
  fraction: 1
}, {
  from: 2000,
  fraction: 1
}, {
  from: 2010,
  fraction: 1
}, {
  from: 2020,
  fraction: 0.66
}, {
  from: 2030,
  fraction: 0
}];
export function Onboarding({
  onSubmit
}: OnboardingProps) {
  return <div className="bg-paper text-ink h-full w-full overflow-y-auto thin-scroll" data-id="element-68" data-mp="23efevbz5k28h">
      <div className="mx-auto grid min-h-full w-full max-w-6xl items-center gap-10 px-5 py-10 sm:px-6 sm:py-16 lg:grid-cols-[1.15fr_1fr] lg:gap-24" data-id="element-69" data-mp="28ejuz0w5euy6">
        <div data-id="element-70" data-mp="2d6l78mtbglo7">
          <p className="text-ink font-mono text-xs font-medium" data-id="element-71" data-mp="2d73aw4ib6265">not.rip</p>
          <h1 className="text-ink mt-5 max-w-xl text-3xl font-extrabold leading-[1.05] tracking-tight sm:mt-6 sm:text-4xl md:text-5xl" data-id="element-72" data-mp="1fp378gjh428a">
            Your life is a finite number of cells. Most of them are already crossed out.
          </h1>
          <p className="text-muted mt-6 max-w-md text-sm leading-relaxed" data-id="element-73" data-mp="3qb6gjadlbz8l">
            Two views: where you are now — the years since your birth and the current year crossed out day by day;
            and your whole life at once, every week a single dot. Crossed out never comes back.
          </p>

          <div className="border-line mt-8 max-w-lg space-y-3 border-t pt-6 sm:mt-12 sm:space-y-4 sm:pt-8" aria-hidden data-id="element-74" data-mp="3bma9ngn9ss9k">
            {DEMO_ROWS.map(row => <StrikeRow key={row.from} columns={10} gapPx={10} labelWidth={0} fraction={row.fraction} thickness={1.5} data-id="element-75" data-mp="36lnp47tgkf0v">
                {Array.from({
              length: 10
            }, (_, i) => {
              const year = row.from + i;
              const lived = (i + 1) / 10 <= row.fraction;
              return <span key={year} className={lived ? 'text-muted text-xs font-medium' : 'text-ink text-xs font-medium'} data-id="element-76" data-mp="10th5nfzxu4ol">
                      {year}
                    </span>;
            })}
              </StrikeRow>)}
          </div>
        </div>

        <div className="border-line bg-surface border p-6 sm:p-8" data-id="element-77" data-mp="15zmahvbdz58l">
          <h2 className="text-ink text-lg font-semibold tracking-tight" data-id="element-78" data-mp="15x9on72icaq9">Where the count begins</h2>
          <p className="text-muted mt-2 mb-8 text-xs leading-relaxed" data-id="element-79" data-mp="1avtc5bwr1ukq">
            These two numbers define the whole grid. You can change them at any time.
          </p>
          <ProfileForm initial={null} submitLabel="Show the grid" onSubmit={onSubmit} data-id="element-80" data-mp="22ok8rnichlai" />
        </div>
      </div>
    </div>;
}